"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleStatus = void 0;
exports.ScheduleStatus = {
    ADMIN_ONLY: 'ADMIN_ONLY',
    PUBLIC: 'PUBLIC',
};
